import {
  type PimProductV12,
  type PimProductV13,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'
import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { type LOCALE } from '../../i18n'
import { recommendationAccessorGetLocalizedProductName } from '../../recommendation'

export const cartIntermediateAccessorGetProductName = ({
  locale,
  product,
}: {
  locale: LOCALE
  product:
    | GkAirRecommendedProductDataWeb
    | PimProductV12
    | PimProductV13
    | PimProductWithVariantsV1
}): string => {
  /**
   * Handle type check:
   * - `UID` - GkAirRecommendedProductDataWeb
   */
  if ('UID' in product) {
    return recommendationAccessorGetLocalizedProductName({
      locale,
      product,
    })
  }

  return product.name
}
